import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Database, Loader2 } from "lucide-react";
import { Dashboard } from "../components/Dashboard";
import { loadDashboardData } from "../lib/api";

export default function DashboardPage() {
  const [state, setState] = useState({ loading: true, data: null, error: null });
  useEffect(() => {
    loadDashboardData().then((data) => setState({ loading: false, data, error: null })).catch((e) => setState({ loading: false, data: null, error: e.message }));
  }, []);
  if (state.loading) return (
    <div className="flex items-center justify-center pt-40 text-slate-400 gap-3" data-testid="dashboard-loading"><Loader2 className="h-5 w-5 animate-spin" /> Loading dataset…</div>
  );
  if (!state.data) return (
    <div className="max-w-3xl mx-auto px-6 pt-28 fade-up" data-testid="dashboard-empty">
      <p className="label-mono mb-4">No data yet</p>
      <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight text-slate-100">Upload a CSV to build your dashboard.</h1>
      <p className="mt-4 text-slate-400">{state.error ? `Could not load data: ${state.error}` : "Once uploaded, the dashboard opens straight away every time you visit."}</p>
      <Link to="/manage" data-testid="empty-go-manage" className="mt-8 inline-flex items-center gap-2 px-4 py-2.5 rounded-md bg-ep hover:bg-ep-hover text-white text-sm">
        <Database className="h-4 w-4" /> Go to Manage data
      </Link>
    </div>
  );
  if (!state.data.users.length) return (
    <div className="max-w-3xl mx-auto px-6 pt-28" data-testid="dashboard-all-hidden">
      <h1 className="font-display text-3xl font-bold text-slate-100">All pickers are hidden.</h1>
      <Link to="/pickers" className="mt-6 inline-flex px-4 py-2.5 rounded-md bg-ep hover:bg-ep-hover text-white text-sm">Choose pickers to show</Link>
    </div>
  );
  return <Dashboard raw={state.data} />;
}
